import { useEffect } from "react";
import { api } from "@/lib/api";

let cache = null;
const loadSeo = () => {
  cache = cache || api.get("/public/cms", { params: { key: "seo" } }).then((r) => r.data || {}).catch(() => ({}));
  return cache;
};
export const clearSeoCache = () => {
  cache = null;
};

const setMeta = (attr, key, value) => {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

const absolute = (u) => (u && u.startsWith("/") ? `${window.location.origin}${u}` : u);

export function applyMeta({ title, description, image }) {
  if (title) document.title = title;
  setMeta("name", "description", description);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:image", absolute(image));
  setMeta("property", "og:url", window.location.href);
  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", description);
  setMeta("name", "twitter:image", absolute(image));
}

export function usePageMeta(page, override) {
  const key = override ? JSON.stringify(override) : "";
  useEffect(() => {
    let live = true;
    loadSeo().then((seo) => {
      if (!live) return;
      const p = (seo.pages || {})[page] || {};
      const site = seo.site_name || "StaffRotas";
      const o = override || {};
      const fill = (v) => (v || "").replace(/\{business\}/g, o.business || "");
      const own = o.title || fill(p.title) || (o.business ? `${o.business} staff app` : "");
      applyMeta({
        title: own ? (own.includes(site) ? own : `${own} | ${site}`) : seo.default_title || site,
        description: o.description || p.description || seo.default_description,
        image: p.image || seo.default_image,
      });
    });
    return () => {
      live = false;
    };
  }, [page, key]); // eslint-disable-line react-hooks/exhaustive-deps
}
